import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import ToggleSection from '../common/interface/toggleSection';
import TextBox from '../common/inputs/textBox';
import CheckBox from '../common/inputs/checkBox';
import Select from '../common/inputs/select';
import Button from '../common/inputs/button';
import ErrorFeedback from '../common/feedback/errorFeedback';
import MetricsEditor from './metricsEditor';
import TemplateEditor from './templateEditor';
import SelectWithTextBoxInput from '../common/inputs/selectWithTextBoxInput';

const FormPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    handleGenerateTemplate,
    generateTemplateData,
    loadingButton,
    fullLoading,
    statusButton,
    modelsData,
    systemDimensionMetrics,
    formData,
    errors,
    entityNameSingular,
    popupState
  } = props;
  return (
    <GlassPopup
      className="form_popup"
      title={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      buttonText={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      type={Constants.interface.popup.types.LATERAL}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
        localesFieldsPath="biTemplateAdmin.fields"
        optionalStatusErrors={{
          "406": intl.formatMessage({id: "common.entity.saveEntityCantDeactivateError"},
             {entityNameSingular: FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "biTemplateAdmin.entityNameSingularWithArticle"})), 
              detail: (errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + errors.message : "")
             })
        }}
      />
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="name"
        data-path="bi_template.name"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.name")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="biTemplateAdmin.fields.name"/>}
        className={("name" in errors) ? "has_error" : null}
      />
      <MetricsEditor
        systemDimensionMetrics={systemDimensionMetrics}
        selectedMetrics={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.system_dimension_metrics")}
        onChange={handleOnChangeForm}
      />
      <div className="row_fields">
        <SelectWithTextBoxInput
          values={
            JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.to_gen_polynomial_id") ?
            JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.to_gen_polynomial_id") : 
            JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.polynomial_id")
          }
          onClickOption={handleOnChangeForm}
          addSelectLocale={ intl.formatMessage({ id: "biTemplateAdmin.fields.to_gen_polynomial_id" })}
          options={InterfaceTooling.getSelectArrayFromArrayOfObjects(modelsData, "id", "name", false)}
          onClearTextCallback={handleOnChangeForm}
          data-path={"bi_template.to_gen_polynomial_id"}
          allowDisplayOptionsButton={true}
        />
        <Button
          className="form_small_button"
          disabled={generateTemplateData.loading || (!JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.to_gen_polynomial_id") && !JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.polynomial_id"))}
          onClick={handleGenerateTemplate}
          labelLocale={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.polynomial_id") ? 
            <FormattedMessage id="biTemplateAdmin.fields.regenerate_button"/> : <FormattedMessage id="biTemplateAdmin.fields.generate_button"/>}
        />
      </div>
      <TemplateEditor
        modelName={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.polynomial_name")}
        generateLoading={generateTemplateData.loading}
        polynomialTree={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.polynomial_tree")}
        onChange={handleOnChangeForm}
      />
      <ToggleSection
        title={<FormattedMessage id="biTemplateAdmin.fields.formatTitle"/>}
      >
        <div>
          <div className="row_fields">
            <Select 
              id="format_type"
              data-path="bi_template.format_type"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.format_type")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="biTemplateAdmin.fields.format_type"/>}
              options={InterfaceTooling.getSelectArray("selectKeys.reportTemplate.format","reportTemplateAdmin.fields.selectValues.format")}
              className={("format_type" in errors) ? "has_error" : null}
            />
            <TextBox 
              styleType={Constants.interface.inputs.styleType.OUTLINED}
              dataType={Constants.selectKeys.metric.dataType.NUMBER}
              type={Constants.interface.inputs.type.TEXT}
              id="decimals"
              data-path="bi_template.decimals"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.decimals")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="biTemplateAdmin.fields.decimals"/>}
              className={("decimals" in errors) ? "has_error" : null}
            />
          </div>
        </div>
      </ToggleSection>
      <div className="row_fields">
        {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.id") && (
          <CheckBox 
            id="active"
            data-path="bi_template.active"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"bi_template.active")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="common.entity.fields.active"/>}
          />
        )}
      </div>
    </GlassPopup>
  );
};

export default FormPopup;



// WEBPACK FOOTER //
// ./source/client/components/biTemplateAdmin/formPopup.jsx